module.exports = __webpack_public_path__ + "static/media/orolig.ef0a5863.mp3";